/*! facett renewal — RECOMMENDED (Swiper PC/SP)
 * WHITETREE 事業カード同型:
 *  - 開始: slidesOffsetBefore で Category/Material 左端揃え
 *  - スライド時: 左余白にもカードが表示される（全幅クリップ）
 *  - 右: 画面端まで覗き見
 * Hero 非干渉: data-facett-recommended のみ
 */
(function () {
  var CSS_HREF = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css';
  var JS_SRC = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js';

  function loadStylesheet(href) {
    if (document.querySelector('link[href="' + href + '"]')) return Promise.resolve();
    return new Promise(function (resolve, reject) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = function () {
        resolve();
      };
      link.onerror = reject;
      document.head.appendChild(link);
    });
  }

  function loadScript(src) {
    if (window.Swiper) return Promise.resolve();
    var existing = document.querySelector('script[data-facett-swiper]');
    if (existing) {
      return new Promise(function (resolve) {
        existing.addEventListener('load', function () {
          resolve();
        });
        if (window.Swiper) resolve();
      });
    }
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.setAttribute('data-facett-swiper', '1');
      script.onload = function () {
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function readCssPx(root, prop, fallback) {
    var probe = document.createElement('div');
    probe.style.cssText =
      'position:absolute;visibility:hidden;pointer-events:none;height:0;width:var(' + prop + ')';
    root.appendChild(probe);
    var px = probe.offsetWidth;
    root.removeChild(probe);
    return px || fallback;
  }

  function getCardW(root) {
    return readCssPx(root, '--facett-rec-card', 206);
  }

  function getGap(root) {
    return readCssPx(root, '--facett-rec-gap', 16);
  }

  function getInsetPx(root) {
    return readCssPx(root, '--facett-rec-inset', 0);
  }

  function getContentMax(root) {
    return readCssPx(root, '--facett-rec-content', 1440);
  }

  /* Category/Material のコンテンツ左端に揃える */
  function getContentOffset(root, el) {
    if (!el) return 24;

    var ref = document.querySelector(
      '.facett-pickup__grid, .facett-material__grid, .facett-category__grid'
    );
    if (ref) {
      var refLeft = Math.round(ref.getBoundingClientRect().left);
      var elLeft = Math.round(el.getBoundingClientRect().left);
      var delta = refLeft - elLeft;
      if (delta !== 0) return Math.max(0, delta);
      if (refLeft > 1) return 0;
    }

    var vw = window.innerWidth || document.documentElement.clientWidth;
    if (vw < 576) {
      return readCssPx(root, '--facett-rec-sp-inset', 24) || 24;
    }

    var inset = getInsetPx(root);
    var content = getContentMax(root);
    return Math.max(inset, Math.round((vw - content) / 2));
  }

  function needsSwipe(el, slideCount, offsetBefore, offsetAfter, cardW, gap) {
    if (!el || slideCount <= 1) return false;
    var w = cardW || 206;
    var g = gap || 8;
    var total =
      slideCount * w + Math.max(0, slideCount - 1) * g + (offsetBefore || 0) + (offsetAfter || 0);
    return total > el.clientWidth + 1;
  }

  function getPager(root) {
    return root ? root.querySelector('[data-facett-recommended-pagination]') : null;
  }

  function clearPager(root) {
    var pager = getPager(root);
    if (!pager) return;
    pager.hidden = true;
    pager.innerHTML = '';
    pager._facettRecPages = 0;
  }

  /* スライド枚数ではなくスクロール距離ベースのページ数（商品が多いため） */
  function getPageCount(swiper) {
    if (!swiper || swiper.isLocked) return 0;
    var range = Math.abs(swiper.maxTranslate() - swiper.minTranslate());
    if (range < 8) return 0;
    var pageW = swiper.size || swiper.width || 1;
    return Math.max(2, Math.round(range / pageW) + 1);
  }

  function goToPage(swiper, pageIndex, pages) {
    if (!swiper || pages < 2) return;
    var maxIdx = Math.max(0, (swiper.slides && swiper.slides.length) || 1) - 1;
    var slideIndex = Math.round((pageIndex / Math.max(1, pages - 1)) * maxIdx);
    swiper.slideTo(slideIndex);
  }

  /* 一旦ページャー非表示（ドット過多）。再有効化時は clearPager のみの early return を外す */
  var PAGER_ENABLED = false;

  function syncPager(root, swiper) {
    if (!PAGER_ENABLED) {
      clearPager(root);
      return;
    }

    var pager = getPager(root);
    if (!pager || !swiper || swiper.isLocked) {
      clearPager(root);
      return;
    }

    var pages = getPageCount(swiper);
    if (pages < 2) {
      clearPager(root);
      return;
    }

    pager.hidden = false;

    if (pager._facettRecPages !== pages) {
      pager.innerHTML = '';
      pager._facettRecPages = pages;
      for (var i = 0; i < pages; i++) {
        (function (idx) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'facett-recommended__bullet';
          btn.setAttribute('aria-label', 'ページ ' + (idx + 1));
          btn.addEventListener('click', function () {
            goToPage(swiper, idx, pages);
          });
          pager.appendChild(btn);
        })(i);
      }
    }

    var active = Math.round((swiper.progress || 0) * (pages - 1));
    if (active < 0) active = 0;
    if (active > pages - 1) active = pages - 1;

    Array.prototype.forEach.call(pager.children, function (el, i) {
      var on = i === active;
      el.classList.toggle('is-active', on);
      if (on) {
        el.setAttribute('aria-current', 'true');
      } else {
        el.removeAttribute('aria-current');
      }
    });
  }

  function destroyRec(root) {
    if (!root) return;
    if (root._facettRecSwiper && typeof root._facettRecSwiper.destroy === 'function') {
      try {
        root._facettRecSwiper.destroy(true, true);
      } catch (e) {
        /* ignore */
      }
    }
    root._facettRecSwiper = null;
    clearPager(root);
    root.dataset.facettRecReady = '';
  }

  function setStatic(root, on) {
    root.classList.toggle('facett-recommended--static', !!on);
    if (on) clearPager(root);
  }

  function initRec(root) {
    if (!root) return;

    var el = root.querySelector('[data-facett-recommended-swiper]');
    if (!el) return;

    var slides = el.querySelectorAll('.swiper-slide');
    var count = slides.length;
    var cardW = getCardW(root);
    var gap = getGap(root);

    destroyRec(root);
    setStatic(root, false);

    var offsetBefore = getContentOffset(root, el);
    /* 終端は右覗き見優先で小さめ（開始揃え分の半分〜inset） */
    var offsetAfter = Math.min(offsetBefore, Math.max(getInsetPx(root), 24));

    if (count <= 1) {
      root.classList.add('facett-recommended--single');
      setStatic(root, true);
      root.dataset.facettRecReady = '1';
      return;
    }

    root.classList.remove('facett-recommended--single');

    if (!needsSwipe(el, count, offsetBefore, offsetAfter, cardW, gap)) {
      setStatic(root, true);
      root.dataset.facettRecReady = '1';
      return;
    }

    if (!window.Swiper) return;

    /* static 解除後に再計測 */
    offsetBefore = getContentOffset(root, el);
    offsetAfter = Math.min(offsetBefore, Math.max(getInsetPx(root), 24));

    root._facettRecSwiper = new window.Swiper(el, {
      loop: false,
      speed: 450,
      slidesPerView: 'auto',
      spaceBetween: gap,
      slidesOffsetBefore: offsetBefore,
      slidesOffsetAfter: offsetAfter,
      watchOverflow: true,
      centerInsufficientSlides: false,
      grabCursor: true,
      a11y: {
        enabled: true,
      },
      on: {
        init: function (swiper) {
          syncPager(root, swiper);
        },
        progress: function (swiper) {
          syncPager(root, swiper);
        },
        resize: function (swiper) {
          syncPager(root, swiper);
        },
        slideChange: function (swiper) {
          syncPager(root, swiper);
        },
      },
    });

    if (root._facettRecSwiper.isLocked) {
      destroyRec(root);
      setStatic(root, true);
    } else {
      syncPager(root, root._facettRecSwiper);
    }

    root.dataset.facettRecReady = '1';
  }

  function anyNeedsSwipe(roots) {
    return Array.prototype.some.call(roots, function (root) {
      var el = root.querySelector('[data-facett-recommended-swiper]');
      if (!el) return false;
      var count = el.querySelectorAll('.swiper-slide').length;
      if (count <= 1) return false;
      var before = getContentOffset(root, el);
      var after = Math.min(before, Math.max(getInsetPx(root), 24));
      return needsSwipe(el, count, before, after, getCardW(root), getGap(root));
    });
  }

  function syncAll() {
    document.querySelectorAll('[data-facett-recommended]').forEach(function (root) {
      initRec(root);
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-facett-recommended]');
    if (!roots.length) return;

    if (anyNeedsSwipe(roots)) {
      Promise.all([loadStylesheet(CSS_HREF), loadScript(JS_SRC)])
        .then(function () {
          window.requestAnimationFrame(syncAll);
        })
        .catch(function () {
          syncAll();
        });
      return;
    }

    syncAll();
    window.requestAnimationFrame(syncAll);
  }

  var resizeTimer = null;
  function onResize() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(boot, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', onResize);
  window.addEventListener('load', boot);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-facett-recommended]');
    if (root) {
      destroyRec(root);
      boot();
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector('[data-facett-recommended]');
    if (root) {
      destroyRec(root);
    }
  });
})();
